import React from "react";

import "../css/footer.css";

function Footer(){

return(
    <div className ="footer-main">&copy;{ (new Date().getFullYear()) } 우리동네</div>
)

}
export default Footer;